import { useLocation } from "react-router-dom";
import bg from "../../assets/images/bg-heading.jpg";
import { Container, Typography, useMediaQuery } from "@mui/material";
import { useEffect } from "react";
type Props = {};

const PageHeader = (props: Props) => {
  const { pathname } = useLocation();
  const isSmallScreen = useMediaQuery("(max-width:899px)");
  const pathArray: Array<string> = pathname.split("/");
  let currentPath = "";
  if (pathArray.length === 3) {
    currentPath = pathArray[2];
  } else if (pathArray.length === 2) {
    if (pathArray[1].length === 0) {
      currentPath = "home";
    } else {
      currentPath = pathArray[1];
    }
  }

  if (currentPath.includes("-")) {
    let newPath = currentPath.split("-").map((index, i) => {
      return index[0].toUpperCase() + index.slice(1);
    });
    currentPath = newPath.join(" ");
  }
  useEffect(() => {}, [currentPath]);
  return (
    <>
      {currentPath === "home" ? (
        <></>
      ) : (
        <Container
          style={{
            backgroundImage: `url(${bg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            minHeight: `${isSmallScreen ? "4rem" : "6rem"}`,
            minWidth: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {currentPath.length > 0 && (
            <>
              {currentPath.includes("-") ? (
                <Typography
                  variant="h2"
                  sx={{
                    fontFamily: "'Baumans', system-ui",
                    color: "white",
                    fontSize: { xs: "15px" },
                  }}
                >
                  {currentPath}
                </Typography>
              ) : (
                <Typography
                  variant="h2"
                  sx={{
                    fontFamily: "'Baumans', system-ui",
                    color: "white",
                    fontSize: { xs: "2rem", md: "4rem" },
                  }}
                >
                  {currentPath[0].toUpperCase() + currentPath.slice(1)}
                </Typography>
              )}
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default PageHeader;
